import { z } from 'zod';

export const NpsSurveyContentType = z.enum(['GAUGE', 'TEXTAREA']);

export type NpsSurveyContentTypeT = z.infer<typeof NpsSurveyContentType>;
